export default '/pricing/extension';
